import React from 'react';
import { Inbox, type LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  /** What is empty, in plain words: "No incidents match these filters". */
  title: string;
  /** One sentence on why, or on what to do next. */
  children?: React.ReactNode;
  /** The next step, when there is one: a button or a link. */
  action?: React.ReactNode;
  icon?: LucideIcon;
  className?: string;
}

/** Says why a list or a panel has nothing to show and what to do about it (item 75). */
const EmptyState: React.FC<EmptyStateProps> = ({ title, children, action, icon: Icon = Inbox, className = '' }) => (
  <div className={`ui-state ${className}`.trim()}>
    <span className="ui-state-icon" aria-hidden>
      <Icon size={16} strokeWidth={1.5} />
    </span>
    <p className="ui-state-title">{title}</p>
    {children && <p className="ui-state-text">{children}</p>}
    {action && <div className="ui-state-action">{action}</div>}
  </div>
);

export default EmptyState;
